export const timeIntervalOption = [
  {
    label: "1m",
    value: "1m",
  },
  {
    label: "5m",
    value: "5m",
  },
  {
    label: "15m",
    value: "15m",
  },
  {
    label: "1h",
    value: "1h",
  },
  {
    label: "1d",
    value: "1d",
  },
];

export const timeRange = [
  {
    label: "1h",
    value: "_1h",
  },
  {
    label: "12h",
    value: "_12h",
  },
  {
    label: "1d",
    value: "_1d",
  },
  {
    label: "7d",
    value: "_7d",
  },
];

export const archiveMode = [
  {
    label: "full node",
    value: false,
  },
  {
    label: "archive",
    value: true,
  },
];
